import { DeviceKey, IfKey } from "./Keys";
import { Link, LinkType } from "./Link";
import { DeviceCategory } from "./DeviceCategory";
import { IfTable, IfEntry } from "../InfoSets/IfTable";
import { Device } from "./Device";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface LinkMemberJson {
//    device_key: DeviceKeyJson;
//    if_key: IfKeyJson;
//    description: string;
//    ssid: string;
//    virtual_port_group: string;
//    link_type: string;
//    network_member: string;
//}

export class LinkMember implements ObjectSerializer {
	public DeviceKey: DeviceKey;
	public get HasDeviceKey(): boolean {
		return !!this.DeviceKey;
	}

	public IfKey: IfKey;
	public get HasIfKey(): boolean {
		return !!this.IfKey;
	}

	public Description: string;
	public get HasDescription() {
		return !!this.Description;
	}

	public SSID: string;
	public get HasSSID(): boolean {
		return !!this.SSID;
    }

    public VirtualPortGroup: string;
    public get HasVirtualPortGroup(): boolean {
        return !!this.VirtualPortGroup;
    }

	public VirtualPort: string;
	public get HasVirtualPort(): boolean {
		return !!this.VirtualPort;
	}

	public ParentLink: Link;

	public LinkType: LinkType;
	public get HasLinkType(): boolean {
		return this.LinkType != LinkType.Unknown;
	}

	public IsNetworkMember: boolean
	public get IsSwitchMember(): boolean {
		if (!this.IsNetworkMember)
			return false;
		if (!this.HasDevice)
			return false;
		if (!this.Device.Categories)
			return false;
		if (this.Device.Categories.Contains(DeviceCategory.Switch))
			return true;
		return false;
	}

	public get IsWirelessApMember(): boolean {

		if (!this.HasDevice)
			return false;
		if (!this.Device.Categories)
			return false;
		if (this.Device.Categories.Contains(DeviceCategory.WirelessAp))
			return true;
		return false;
	}

	public Device: Device;
	public get HasDevice(): boolean {
		return !!this.Device;
	}

	public IfEntry: IfEntry;
	public get HasIfEntry(): boolean {
		return this.IfEntry != null;
	}

	constructor(deviceKey?: DeviceKey, ifKey?: IfKey) {
		this.Init();

        if (deviceKey || ifKey) {
            if (ifKey) {
                this.IfKey = ifKey;
            }
            else if (deviceKey) {
                this.DeviceKey = deviceKey;
            }
        }
	}

	private Init() {
		this.DeviceKey = null;
		this.IfKey = null;
		this.Description = "";
        this.SSID = "";
		this.VirtualPortGroup = "";
		this.VirtualPort = "";

		this.ParentLink = null;
		this.LinkType = LinkType.Unknown;
	}

	public Clear() {
		this.Init();
	}

	public get DisplayName(): string {

		var deviceString = "";
		if (this.HasDevice)
			deviceString = this.Device.DisplayName;
		else if (this.HasDeviceKey)
			deviceString = this.DeviceKey.toString();

		var ifString = "";
		if (this.HasIfEntry)
			ifString = this.IfEntry.DisplayName;
		else if (this.HasIfKey)
			ifString = this.IfKey.toString();

		if (deviceString != "" && ifString != "")
			return deviceString + "(" + ifString + ")";
		else if (deviceString != "")
			return deviceString;
		else if (ifString != "")
			return ifString;
		else
			return "";
	}

	public toString(): string {
		return this.DisplayName;
	}

	//public Equals(obj: any): boolean {
	//	if (!obj)
	//		return false;

	//	if (obj === this)
	//		return true;

	//	if (!(obj instanceof LinkMember))
	//		return false;

	//	var other = <LinkMember> obj;

	//	if (!ObjUtils.Equals(other.IfKey, this.IfKey))
	//		return false;

	//	if (!ObjUtils.Equals(other.DeviceKey, this.DeviceKey))
	//		return false;

	//	if (!ObjUtils.Equals(other.Description, this.Description))
	//		return false;
	//}

	//public GetHashCode(): number {
	//	var result = 0;

	//	if (this.HasIfKey)
	//		result ^= this.IfKey.GetHashCode();

	//	if (this.HasDeviceKey)
	//		result ^= this.DeviceKey.GetHashCode();

	//	if (this.HasDescription)
	//		result ^= ObjUtils.GetHashCode(this.Description);

	//	return result;
 //   }

    //public static FromJson(json: LinkMemberJson): LinkMember {
    //    var result = new LinkMember();

    //    if (json.device_key !== undefined)
    //        result.DeviceKey = DeviceKey.FromJson(json.device_key);

    //    if (json.if_key !== undefined)
    //        result.IfKey = IfKey.FromJson(json.if_key);

    //    if (json.description !== undefined)
    //        result.Description = json.description;

    //    if (json.ssid !== undefined)
    //        result.SSID = json.ssid;

    //    if (json.virtual_port_group !== undefined)
    //        result.VirtualPortGroup = json.virtual_port_group;

    //    if (json.link_type !== undefined)
    //        result.LinkType = LinkType[json.link_type];

    //    if (json.network_member !== undefined)
    //        result.IsNetworkMember = StringUtils.ParseBool(json.network_member);

    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.link_member = {};
		obj = obj.link_member;

		if (this.HasDeviceKey)
			this.DeviceKey.Write(obj, context);

		if (this.HasIfKey)
			this.IfKey.Write(obj, context);

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasSSID)
			obj.ssid = this.SSID;

		if (this.HasVirtualPortGroup)
			obj.virtual_port_group = this.VirtualPortGroup;

		if (this.HasVirtualPort)
			obj.virtual_port = this.VirtualPort;

		if (this.HasLinkType)
			obj.link_type = LinkType[this.LinkType];

		obj.network_member = ValueEncoder.EncodeBoolean(this.IsNetworkMember);
	}

	public Read(obj: any, context: any): void {
		if (!obj.link_member)
			throw new Error();
		obj = obj.link_member;

		if (obj.device_key !== undefined) {
			this.DeviceKey = new DeviceKey();
			this.DeviceKey.Read(obj, context);
		}

		if (obj.if_key !== undefined) {
			this.IfKey = new IfKey();
			this.IfKey.Read(obj, context);
		}

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.ssid !== undefined)
			this.SSID = obj.ssid;

		if (obj.virtual_port_group !== undefined)
			this.VirtualPortGroup = obj.virtual_port_group;

		if (obj.virtual_port !== undefined)
			this.VirtualPort = obj.virtual_port;

		if (obj.link_type !== undefined)
			this.LinkType = LinkType[<string>obj.link_type];

		if (obj.network_member !== undefined)
			this.IsNetworkMember = ValueEncoder.DecodeBoolean(obj.network_member);
	}

}
